/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";
// import Icon from "@mui/material/Icon"; 
// import IconButton from "@mui/material/IconButton";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";

// @mui material components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  getWarehouses,
  getRmTraceability,
  getItemMaster,
  getZonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getSubModulesByRoleId,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getAcn,
  createRm,
  uploadForRmTraceability,
  getRelationLocation,
  getWarehousesByMovement,
  deleteRm,
  editRM,
  getLevelsByWarehouse,
  getDppIds,
  uploadForUrl,
  getDppDocumentsImage,
  getPoNumberByDppId,
  getInsertPoNumber,
  getDynamicColumn,
  createDynamicColumn,
  getSupplierType,
} from "../../../store";

// Cookies
import Cookies from "universal-cookie";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import { CSVLink } from "react-csv";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 750, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 750, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const RMTRACEABILITY = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deleteRm,
  warehouses,
  getRmTraceability,
  getRmTraceReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editRM,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createRm,
  getWarehousesByMovement,
  uploadForRmTraceability,
  getLevelsByWarehouse,
  levelsByWarehouseReducer,
  getDppIds,
  getDynamicColumnReducer,
  getDPPReducer,
  getDppDocumentsImageReducer,
  dppIdSelectedForGlobalFilter,
  getPOnumberReducer,
  uploadForUrl,
  getDppDocumentsImage,
  getPoNumberByDppId,
  getInsertPoNumber,
  getPOnumberInsertReducer,
  getSupplierTypeReducer,
  getSupplierType
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getSupplierType(jwtToken);
  }, []);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "852fd581-2cd9-40d1-b0f6-e29dd61566ff"
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "9ac6d686-57e6-47a7-ad0a-8fe8ad2bbd38"
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "94e1aedf-8637-4d27-9079-2812f320e458"
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "af3613f7-f80f-4716-9200-d5b33f6fee9f"
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "1a0444fb-a007-4922-8d17-9d4ccf6cf702"
    )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);

  };
  const [warehouseIdSelectedSM, setWarehouseIdSelectedSM] = useState("");

  const handleChangeWarehouseSM = (selectedData) => {
    setWarehouseIdSelectedSM(selectedData);

  };

  const [warehouseIdSelectedT, setWarehouseIdSelectedT] = useState("");

  const handleChangeWarehouseT = (selectedData) => {
    setWarehouseIdSelectedT(selectedData);
  };

  const [warehouseIdSelectedEdit, setWarehouseIdSelectedEdit] = useState("");

  const handleChangeWarehouseEdit = (selectedData) => {
    setWarehouseIdSelectedEdit(selectedData);

  };
  const [warehouseIdSelectedSMEdit, setWarehouseIdSelectedSMEdit] = useState("");

  const handleChangeWarehouseSMEdit = (selectedData) => {
    setWarehouseIdSelectedSMEdit(selectedData);

  };

  const [warehouseIdSelectedTEdit, setWarehouseIdSelectedTEdit] = useState("");

  const handleChangeWarehouseTEdit = (selectedData) => {
    setWarehouseIdSelectedTEdit(selectedData);
  };

  const activeDataOptions = [
    { label: "Yes", value: "1" },
    { label: "No", value: "0" },
  ];
  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  // useEffect(() => {
  //   getRmTraceability(jwtToken);
  // }, []);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const [state, setState] = useState({
    columns: [
      { Header: "dpp Code", accessor: "dppCode" },
      { Header: "fg Code", accessor: "fgCode" },
      { Header: "description", accessor: "description" },
      { Header: "batch ", accessor: "batchNo" },
      { Header: "Item Code", accessor: "rmItemCode" },
      { Header: "vendor ", accessor: "vendorName" },
      { Header: "po Number", accessor: "poNumber" },
      {
        Header: "po Date",
        accessor: "poDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(new Date(value), "dd/MM/yyyy")
            : "";
        },
      },
      { Header: "qty ", accessor: "qtyPO" },
      { Header: "carbon Footprint (kg CO₂e)", accessor: "carbonFootprint" },
      { Header: " resourceType ", accessor: "resourceType" },
      { Header: " recycledMaterial ", accessor: "recycledMaterial" },
      { Header: " bioBasedMaterial ", accessor: "bioBasedMaterial" },
      { Header: " supplierName ", accessor: "supplierName" },
      { Header: " organicCotton ", accessor: "organicCotton" },
      { Header: " po Qty Uom ", accessor: "poQtyUom" },
      { Header: "asn Number ", accessor: "asnNumber" },
      { Header: "grn Number", accessor: "grnNumber" },
      { Header: "Supplier Audits", accessor: "supplierAudits" },
      { Header: "Traceability", accessor: "traceability" },
      { Header: "Ethical Score", accessor: "ethicalScore" },
      { Header: "Source Mapping", accessor: "sourceMapping" },
      { Header: "Material Purity", accessor: "materialPurity" },
      { Header: "recyclability (%)", accessor: "recyclability" },
      { Header: "country Of Origin", accessor: "countryOfOrigin" },

      { Header: "Mineing Site Name", accessor: "mineName" },
      { Header: "Mimeig Country", accessor: "mineCountry" },
      { Header: "Refinary Name", accessor: "refineryName" },
      { Header: "Refinary Country", accessor: "refineryCountry" },

      {
        Header: "file", accessor: "file", cannotSearch: true,
        cannotSort: true,
      },
      // { Header: "rm Trace Id", accessor: "rmTraceId" },
      // { Header: "remark", accessor: "remark" },
      {
        Header: "GRN Date",
        accessor: "rmReceivedDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(new Date(value), "dd/MM/yyyy")
            : "";
        },
      },
      // { Header: "doc Url", accessor: "docUrl" },
      // { Header: "poDate", accessor: "poDate" },
      // { Header: "status", accessor: "status" , cannotSearch: true,
      //   cannotSort: true, },

      // { Header: "Created By", accessor: "cdBy" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  // const headers = [
  //   { label: "dppCode", key: "dppCode" },
  //   // { label: "fgCode", key: "fgCode" },
  //   { label: "description", key: "description" },
  //   { label: "batch", key: "batchNo" },
  //   { label: "recyclability", key: "recyclability" },
  //   { label: "country Of Origin", key: "countryOfOrigin" },
  //   // { label: "rm ImageUrl", key: "rmImageUrl" },
  //   { label: "ItemCode", key: "rmItemCode" },
  //   { label: "vendor", key: "vendorName" },
  //   { label: "resourceType", key: "resourceType" },

  //   { label: "recycledMaterial", key: "recycledMaterial" },
  //   { label: "bioBasedMaterial", key: "bioBasedMaterial" },
  //   { label: "supplierName", key: "supplierName" },
  //   { label: "organicCotton", key: "organicCotton" },
  //   { label: "poQtyUom", key: "poQtyUom" }, { label: "poNumber", key: "poNumber" },
  //   { label: "supplierAudits", key: "supplierAudits" },
  //   { label: "traceability", key: "traceability" },
  //   { label: "ethicalScore", key: "ethicalScore" },
  //   { label: "sourceMapping", key: "sourceMapping" },
  //   { label: "materialPurity", key: "materialPurity" },
  //   { label: "po Date", key: "createdDate2" },
  //   { label: "qty", key: "qtyPO" },
  //   { label: "carbonFootprint", key: "carbonFootprint" },
  //   { label: "asnNumber", key: "asnNumber" },
  //   { label: "grnNumber", key: "grnNumber" },
  //   { label: "grn Date", key: "createdDate" },
  // ];

  // const headersForTemp = [
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "fgCode", key: "fgCode" },
  //   { label: "batchNo", key: "batchNo" },
  //   { label: "rmItemCode", key: "rmItemCode" },
  //   { label: "vendorName", key: "vendorName" },
  //   { label: "poNumber", key: "poNumber" },
  //   { label: "poDate", key: "poDate" },
  //   { label: "qtyPO", key: "qtyPO" },
  //   { label: "asnNumber", key: "asnNumber" },
  //   { label: "grnNumber", key: "grnNumber" },
  //   { label: "rmReceivedDate", key: "rmReceivedDate" },
  //   { label: "docUrl", key: "docUrl" },
  //   { label: "remark", key: "remark" },
  //   { label: "carbonFootprint", key: "carbonFootprint" },
  //   { label: "rmImageUrl", key: "rmImageUrl" },
  //   { label: "recyclability", key: "recyclability" },
  //   { label: "countryOfOrigin", key: "countryOfOrigin" },
  //   { label: "resourceType", key: "resourceType" },
  //   { label: "supplierAudits", key: "supplierAudits" },
  //   { label: "traceability", key: "traceability" },
  //   { label: "ethicalScore", key: "ethicalScore" },
  //   { label: "sourceMapping", key: "sourceMapping" },
  //   { label: "materialPurity", key: "materialPurity" }
  // ];


  // --- 1. Table Data Download (Listing) ke Headers ---
  // Isme 'label' ko proper format (Title Case) mein likha hai taaki Excel mein heading achhi dikhe
  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "FG Code", key: "fgCode" },
    { label: "Batch Number", key: "batchNumber" },
    { label: "RM Item Code", key: "rmItemCode" },
    { label: "Vendor Name", key: "vendorName" },
    { label: "PO Number", key: "poNumber" },
    { label: "PO Date", key: "poDate" },
    { label: "PO Quantity", key: "poQuantity" },
    { label: "ASN Number", key: "asnNumber" },
    { label: "GRN Number", key: "grnNumber" },
    { label: "RM Received Date", key: "rmReceivedDate" },
    { label: "Carbon Footprint", key: "carbonFootprint" },
    { label: "Recyclability Percentage", key: "recyclabilityPercentage" },
    { label: "Country Of Origin", key: "countryOfOrigin" },
    { label: "Resource Type", key: "resourceType" },
    { label: "Supplier Audits", key: "supplierAudits" },
    { label: "Traceability", key: "traceability" },
    { label: "Ethical Score", key: "ethicalScore" },
    { label: "Source Mapping", key: "sourceMapping" },
    { label: "Material Purity", key: "materialPurity" },
    { label: "Remark", key: "remark" }
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "fgCode", key: "fgCode" },
    { label: "batchNumber", key: "batchNumber" },
    { label: "rmItemCode", key: "rmItemCode" },
    { label: "vendorName", key: "vendorName" },
    { label: "poNumber", key: "poNumber" },
    { label: "poDate", key: "poDate" },
    { label: "poQuantity", key: "poQuantity" },
    { label: "asnNumber", key: "asnNumber" },
    { label: "grnNumber", key: "grnNumber" },
    { label: "rmReceivedDate", key: "rmReceivedDate" },
    { label: "carbonFootprint", key: "carbonFootprint" },
    { label: "recyclabilityPercentage", key: "recyclabilityPercentage" },
    { label: "countryOfOrigin", key: "countryOfOrigin" },
    { label: "resourceType", key: "resourceType" },
    { label: "supplierAudits", key: "supplierAudits" },
    { label: "traceability", key: "traceability" },
    { label: "ethicalScore", key: "ethicalScore" },
    { label: "sourceMapping", key: "sourceMapping" },
    { label: "materialPurity", key: "materialPurity" },
    { label: "remark", key: "remark" }
  ];

  const csvLink = {
    filename: "Rm Items List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Rm Items Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [loading, setLoading] = useState(true);

  const [currentFile, setCurrentFile] = useState(null);

  const handleOpenDocument = (item) => {
    // Trigger API call
    getDppDocumentsImage(item.moduleName, item.type, item.name, jwtToken);
  };
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getRmTraceReducer.rmTrace.data
      ? getRmTraceReducer.rmTrace.data
      : [];
    // setPaginationObj(getRmTraceReducer?.rmTrace?.pagination);
    setLoading(getRmTraceReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.rmReceivedDate);
      const formatDate2 = new Date(item.poDate);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),

        createdDate2: format(new Date(formatDate2), "dd/MM/yyyy"),
        rmTraceId: item.rmTraceId,
        // rmImageUrl: item.rmImageUrl,
        recyclability: item.recyclability,
        countryOfOrigin: item.countryOfOrigin,
        file: item.name ? (
          <MDButton
            variant="gradient"
            color="info"
            iconOnly
            size="small"
            style={{ padding: "4px", minWidth: "32px" }}
            onClick={() => handleOpenDocument(item)}
          >
            <Icon>description</Icon>
          </MDButton>
        ) : "-",

        carbonFootprint: item.carbonFootprint,
        resourceType: item.resourceType,
        dppCode: item.dppCode,
        mineName: item.mineName,
        mineCountry: item.mineCountry,
        refineryName: item.refineryName,
        refineryCountry: item.refineryCountry,

        recycledMaterial: item.recycledMaterial,
        bioBasedMaterial: item.bioBasedMaterial,
        organicCotton: item.organicCotton,
        poQtyUom: item.poQtyUom,
        supplierName: item.supplierName,

        batchNo: item.batchNo,
        description: item.description,
        vendorName: item.vendorName,

        supplierAudits: item.supplierAudits,
        traceability: item.traceability,
        ethicalScore: item.ethicalScore,
        sourceMapping: item.sourceMapping,
        materialPurity: item.materialPurity,
        fgCode: item.fgCode,
        remark: item.remark,
        poNumber: item.poNumber,
        qtyPO: item.qtyPO,
        asnNumber: item.asnNumber,
        docUrl: item.docUrl,
        grnNumber: item.grnNumber,
        rmItemCode: item.rmItemCode,
        rmReceivedDate: item.rmReceivedDate,
        version: item.version,
        productId: item.productId,
        cdBy: item.cdBy,
        poDate: item.poDate,

        status: (
          <button
            type="button"
            className={
              (item.status === 1 && `status-success`) ||
              (item.status === 0 && `status-error`) ||
              (item.status === 2 && `status-warning`)
            }
            style={{ width: "7rem", cursor: "pointer" }}
          >
            {(item.status === 1 && `Active`) ||
              (item.status === 0 && `Inactive`) ||
              (item.status === 2 && `Unarchived`)}
          </button>
        ),

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,
        // createdDate: format(
        //   addMinutes(formatDate, formatDate.getTimezoneOffset()),
        //   "dd/MM/yyyy hh:mm aaa"
        // ),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getRmTraceReducer]);



  // Watch reducer for updates
  useEffect(() => {
    const data = getDppDocumentsImageReducer.documents.data;

    if (data) {
      // Set the file for temporary use
      setCurrentFile(data);

      // Reset local state in reducer copy
      getDppDocumentsImageReducer.documents.data = null; // clears it locally
    }
  }, [getDppDocumentsImageReducer.documents.data]);

  // Optional: automatically clear currentFile after some time
  useEffect(() => {
    if (currentFile) {
      const timer = setTimeout(() => setCurrentFile(null), 1000); // 5 seconds
      return () => clearTimeout(timer);
    }
  }, [currentFile]);


  // Open file whenever currentFile updates
  useEffect(() => {
    if (!currentFile) return;

    let fileUrl;
    if (typeof currentFile === "string") fileUrl = currentFile;
    else if (currentFile.url) fileUrl = currentFile.url;
    else if (currentFile.base64) {
      const byteCharacters = atob(currentFile.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: currentFile.type || "application/octet-stream" });
      fileUrl = URL.createObjectURL(blob);
    } else return;

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }, [currentFile]);



  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    []
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});

    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setSelectedIndustry(null)
    setdppIdSelected("");
    formik.setValues(initialValues);
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  const initialValues = {
    DPPID: "",
    // FGCode: "",
    BatchCode: "",
    ItemCode: "",
    Vendor: "",
    PONumber: "",
    PODate: "",
    Quantity: "",
    description: "",
    ASNNumber: "",
    GRNumber: "",
    GRDate: "",
    carbonFootprint: "",
    rmImageUrl: "",
    countryOrigin: "",
    recyclebility: "",
    resourceType: "",
    file: "",
    materialCertificateFile: "",
    mineName: "",
    mineCountry: "",
    refineryName: "",
    refineryCountry: "",
    GRNumber: "",
    poQtyUom: "",
    // rackName: "",
    // bin: "",
  };

  const validationSchema = Yup.object({
    // DPPID: Yup.object()
    //   .required("DPPCode is required"),

    // FGCode: Yup.string().trim().required("FGCode is required"),

    // rmImageUrl: Yup.string().trim().required("rmImageUrl is required"),


    countryOrigin: Yup.string().trim().required(" "),
    ethicalScore: Yup.string().trim().required(" "),
    materialPurity: Yup.string().trim().required(" "),
    recyclebility: Yup.string().trim().required(" "),

    Traceability: Yup.object()
      .required(" "),

    SourceMapping: Yup.object()
      .required(" "),

    SupplierAudits: Yup.object()
      .required(" "),


    BatchCode: Yup.string().trim().required(" "),
    description: Yup.string().trim().required(" "),

    ItemCode: Yup.string().trim().required(" "),

    Vendor: Yup.string().trim().required(" "),




    PONumber: Yup.string().trim().required(" "),
    mineName: Yup.string().trim(),
    // .required(" "),

    PODate: Yup.date()
      .typeError("PODate must be a valid date")
      .required(" "),

    Quantity: Yup.number()
      .typeError("Quantity must be a number")
      .required(" "),

    ASNNumber: Yup.string().trim().required(" "),

    GRNumber: Yup.string().trim().required(" "),
    resourceType: Yup.string().trim().required(" "),

    GRDate: Yup.date()
      .typeError("GRN Date must be a valid date")
      .required(" "),

    carbonFootprint: Yup.string()
      .trim()
      .required(" "),

    poQtyUom: Yup.string().required(" "),



    mineName: Yup.string()
      .matches(/^[a-zA-Z0-9\s,.-]+$/, "Invalid characters. Use alphabets, spaces, commas."),
    // .required(" "),
    mineCountry: Yup.string()
      .matches(/^[a-zA-Z\s,]+$/, "Only alphabets, spaces, and commas allowed."),
    // .required(" "),
    refineryName: Yup.string()
      .matches(/^[a-zA-Z0-9\s,.-]+$/, "Invalid characters. Use alphabets, spaces, commas."),
    // .required(" "),
    refineryCountry: Yup.string()
      .matches(/^[a-zA-Z\s,]+$/, "Only alphabets, spaces, and commas allowed."),
    // .required(" "),


  });



  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const [dppIdSelected, setdppIdSelected] = useState("");

  const handleChangeDpp = (selectedData) => {
    setdppIdSelected(selectedData);

    setSelectedIndustry(selectedData?.industry);
    formik.setFieldValue("dppId", selectedData?.value);
  };
  const [supplierIdSelected, setSupplierIdSelected] = useState("");

  const handleChangeSupplier = (selectedData) => {
    setSupplierIdSelected(selectedData);

  };
  const [supplierIdSelectedForEdit, setSupplierIdSelectedForEdit] = useState("");

  const handleChangeSupplierForEdit = (selectedData) => {
    setSupplierIdSelectedForEdit(selectedData);

  };

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter) {
      setdppIdSelected(dppIdSelectedForGlobalFilter);
    }
  }, [dppIdSelectedForGlobalFilter]);

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getRmTraceability(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getRmTraceability(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
        industry: zone.industryId,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);
  const [supplierOptions, setSupplierOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getSupplierTypeReducer.dpp.data ? getSupplierTypeReducer.dpp.data : [];

    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.supplierName,
        value: zone.supplierId,
      });
    });
    setSupplierOptions(tempgetDPPReducer);
  }, [getSupplierTypeReducer]);

  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const handleChangeDppForUpdate = (selectedData) => {
    setdppIdForUpdateSelected(selectedData);
  };
  useEffect(() => {
    getDppIds(jwtToken);
  }, []);



  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");
  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");

    const formData = new FormData();

    formData.append("cdBy", userId);
    formData.append("dppId", dppIdSelected?.value);
    formData.append("fgCode", values.FGCode);
    formData.append("batchNo", values.BatchCode);
    formData.append("rmItemCode", values.ItemCode);
    formData.append("vendorName", values.Vendor);
    formData.append("poNumber", values.PONumber);
    formData.append("poDate", values.PODate);
    formData.append("description", values.description);
    formData.append("recyclability", values.recyclebility);
    formData.append("resourceType", values.resourceType);
    formData.append("recycledMaterial", values.recycledMaterial);
    formData.append("bioBasedMaterial", values.bioBasedMaterial);
    formData.append("supplierId", supplierIdSelected?.value);
    formData.append("organicCotton", values.organicCotton);
    formData.append("poQtyUom", values.poQtyUom);
    formData.append("traceability", warehouseIdSelectedT?.value);
    formData.append("sourceMapping", warehouseIdSelectedSM?.value);
    formData.append("supplierAudits", warehouseIdSelected?.value);
    formData.append("ethicalScore", values.ethicalScore);
    formData.append("materialPurity", values.materialPurity);
    formData.append("rmImageUrl", values.rmImageUrl);
    formData.append("countryOfOrigin", values.countryOrigin);
    formData.append("carbonFootprint", String(values.carbonFootprint ?? ""));
    formData.append("qtyPO", values.Quantity);
    formData.append("asnNumber", values.ASNNumber);
    formData.append("grnNumber", values.GRNumber);
    formData.append("rmReceivedDate", values.GRDate);
    formData.append("documentType", "rmTracebilityImage");
    formData.append("moduleName", "rmTraceability");
    formData.append("mineName", values.mineName);
    formData.append("mineCountry", values.mineCountry);
    formData.append("refineryName", values.refineryName);
    formData.append("refineryCountry", values.refineryCountry);


    // ✅ Attach RM image / document
    if (values.file) {
      formData.append("attachments", values.file);
    }
    if (values.materialCertificateFile) {
      formData.append("materialCertificateFile", values.materialCertificateFile);
    }

    let res = await createRm(formData, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getOpenBinsByWarehouseAndZone(
        warehouseIdSelected?.value,
        zoneIdSelected
      );
      getRmTraceability(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});

      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    } else {
      setErrorMsg(res?.data?.data?.msg);
      // formik.setValues(initialValues);
      setAllocateButtonName("Create");
      setIsErrorAllocateItem(true);
    }

    // resetForm();
  };



  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let rmTraceId = singleDataForDelete.rmTraceId;
    // let userId = singleDataForDelete.userId;

    let res = await deleteRm(rmTraceId);

    if (res.status) {
      getRmTraceability(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({

    initialValues,
    onSubmit,
    validationSchema,
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getRmTraceability(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const handleOpenUpdateModal = (singleData) => {
    setWarehouseTypesSelectedForEdit({
      label: singleData.warehouseCode,
      value: singleData.warehouseId,
    });

    setWarehouseIdSelectedEdit({
      label: singleData.supplierAudits,
      value: singleData.supplierAudits?.toLowerCase() === "Yes" ? 0 : 1,
    });

    setWarehouseIdSelectedSMEdit({
      label: singleData.sourceMapping,
      value: singleData.sourceMapping?.toLowerCase() === "Yes" ? 0 : 1,
    });

    setWarehouseIdSelectedTEdit({
      label: singleData.traceability,
      value: singleData.traceability?.toLowerCase() === "Yes" ? 0 : 1,
    });
    // setWarehouseIdSelectedTEdit({
    //   label: singleData.traceability,
    //   value: singleData.traceability,
    // });
    setItemCodeSelectedForEdit({
      label: singleData.itemCode,
      value: singleData.itemId,
    });
    setSupplierIdSelectedForEdit({
      label: singleData.supplierName,
      value: singleData.supplierId,
    });
    setAcnTypeSelectedForEdit({
      label: singleData.acnCode,
      value: singleData.acnId,
    });
    setZoneSelectedForEdit({
      label: singleData.zone,
      value: singleData.zoneId,
    });
    setSectionSelectedForEdit({
      label: singleData.section,
      value: singleData.sectionId,
    });
    setRackSelectedForEdit({
      label: singleData.rack,
      value: singleData.rackId,
    });
    setLocationSelectedForEdit({
      label: singleData.location,
      value: singleData.locationId,
    });
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    formikForUpdate.setValues(initialValueForUpdate);

    formikForUpdate.setErrors({});

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };

  const initialValueForUpdate = {
    DPPID: singleFgDataForUpdate.dppCode,
    FGCode: singleFgDataForUpdate.fgCode,
    BatchCode: singleFgDataForUpdate.batchNo,
    ItemCode: singleFgDataForUpdate.rmItemCode,
    Vendor: singleFgDataForUpdate.vendorName,
    PONumber: singleFgDataForUpdate.poNumber,

    recycledMaterial: singleFgDataForUpdate.recycledMaterial,
    bioBasedMaterial: singleFgDataForUpdate.bioBasedMaterial,
    organicCotton: singleFgDataForUpdate.organicCotton,
    poQtyUom: singleFgDataForUpdate.poQtyUom,

    PODate: singleFgDataForUpdate.poDate
      ? (() => {
        const [month, day, year] = singleFgDataForUpdate.poDate.split("/");
        return `${year}-${month}-${day}`;
      })()
      : "",

    Quantity: singleFgDataForUpdate.qtyPO,
    ASNNumber: singleFgDataForUpdate.asnNumber,

    ethicalScore: singleFgDataForUpdate.ethicalScore ?? "",
    materialPurity: singleFgDataForUpdate.materialPurity ?? "",

    GRNumber: singleFgDataForUpdate.grnNumber,
    recyclability: singleFgDataForUpdate.recyclability,
    rmImageUrl: singleFgDataForUpdate.rmImageUrl,
    countryOrigin: singleFgDataForUpdate.countryOfOrigin,
    resourceType: singleFgDataForUpdate.resourceType,
    carbonFootprint: singleFgDataForUpdate.carbonFootprint,
    description: singleFgDataForUpdate.description,
    refineryName: singleFgDataForUpdate.refineryName,
    refineryCountry: singleFgDataForUpdate.refineryCountry,
    mineName: singleFgDataForUpdate.mineName,
    mineCountry: singleFgDataForUpdate.mineCountry,

    GRDate: singleFgDataForUpdate.rmReceivedDate
      ? (() => {
        const [month, day, year] = singleFgDataForUpdate.rmReceivedDate.split("/");
        return `${year}-${month}-${day}`;
      })()
      : "",

    // Add these
    SupplierAudits: singleFgDataForUpdate.supplierAudits
      ? {
        label: singleFgDataForUpdate.supplierAudits,
        value:
          singleFgDataForUpdate.supplierAudits === "Yes" ? 1 : 0,
      }
      : null,

    SourceMapping: singleFgDataForUpdate.sourceMapping
      ? {
        label: singleFgDataForUpdate.sourceMapping,
        value:
          singleFgDataForUpdate.sourceMapping === "Yes" ? 1 : 0,
      }
      : null,

    Traceability: singleFgDataForUpdate.traceability
      ? {
        label: singleFgDataForUpdate.traceability,
        value:
          singleFgDataForUpdate.traceability === "Yes" ? 1 : 0,
      }
      : null,
  };
  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  console.log("warehouseIdSelectedSMEdit?.value", warehouseIdSelectedSMEdit?.value)

  const [editButtonName, setEditButtonName] = useState("Update");
  const onSubmitForUpdate = async (values) => {

    setEditButtonName("Please wait...");
    const formData = new FormData();
    formData.append("rmTraceId", singleFgDataForUpdate.rmTraceId);
    formData.append("udBy", userId);
    formData.append("dppId", singleFgDataForUpdate?.dppId);
    formData.append("fgCode", values.FGCode);
    formData.append("recycledMaterial", values.recycledMaterial);
    formData.append("bioBasedMaterial", values.bioBasedMaterial);
    formData.append("organicCotton", values.organicCotton);
    formData.append("poQtyUom", values.poQtyUom);
    formData.append("batchNo", values.BatchCode);
    formData.append("rmItemCode", values.ItemCode);
    formData.append("vendorName", values.Vendor);
    formData.append("poNumber", values.PONumber);
    formData.append("traceability", warehouseIdSelectedTEdit?.value);
    formData.append("sourceMapping", warehouseIdSelectedSMEdit?.value);
    formData.append("supplierAudits", warehouseIdSelectedEdit?.value);

    formData.append("ethicalScore", values.ethicalScore);
    formData.append("materialPurity", values.materialPurity);

    formData.append("supplierId", supplierIdSelectedForEdit?.value);
    formData.append("description", values.description);
    formData.append("poDate", values.PODate);
    formData.append("qtyPO", values.Quantity);
    formData.append("asnNumber", values.ASNNumber);
    formData.append("grnNumber", values.GRNumber);
    formData.append("rmReceivedDate", values.GRDate);

    formData.append("resourceType", values.resourceType);
    formData.append("recyclability", values.recyclability);
    // formData.append("rmImageUrl", values.rmImageUrl);
    formData.append("countryOfOrigin", values.countryOrigin);
    formData.append(
      "carbonFootprint",
      String(values.carbonFootprint ?? "")
    );
    formData.append("documentType", "rmTracebilityImage");
    formData.append("moduleName", "rmTraceability");
    formData.append("mineName", values.mineName);
    formData.append("mineCountry", values.mineCountry);
    formData.append("refineryName", values.refineryName);
    formData.append("refineryCountry", values.refineryCountry);


    // ✅ attach file ONLY if user selected a new one
    if (values.file) {
      formData.append("attachments", values.file);
    }

    let res = await editRM(formData, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getRmTraceability(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };



  const validationSchemaForAssembly = Yup.object({
    SupplierAudits: Yup.object()
      .nullable()
      .required(" "),

    SourceMapping: Yup.object()
      .nullable()
      .required(" "),

    Traceability: Yup.object()
      .nullable()
      .required(" "),

    ethicalScore: Yup.number()
      .typeError("Enter a valid number")
      .min(0, "Minimum is 0")
      .max(100, "Maximum is 100")
      .required(" "),

    materialPurity: Yup.number()
      .typeError("Enter a valid number")
      .min(0, "Minimum is 0")
      .max(100, "Maximum is 100")
      .required(" "),
  });

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,

    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForAssembly,
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getRmTraceability(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadForRmTraceability(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        getRmTraceability(dppIdSelectedForGlobalFilter?.value, jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const subModuleId = "852fd581-2cd9-40d1-b0f6-e29dd61566ff";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getRmTraceability(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [isUploading, setIsUploading] = useState(false);
  const uploadDocumentHandler = async () => {
    if (!formik.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    // 🔑 Match backend keys
    data.append("File", formik.values.file);        // file
    data.append("module_name", "rm_traceability");          // text

    try {
      const res = await uploadForUrl(data, jwtToken);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill RM Image URL
        formik.setFieldValue("rmImageUrl", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };
  const uploadDocumentHandlerForUpdate = async () => {
    if (!formikForUpdate.values.file) return;

    setIsUploading(true);

    const data = new FormData();

    // 🔑 Must match Postman keys

    // 🔑 MUST match Postman keys

    data.append("File", formikForUpdate.values.file);        // file
    data.append("module_name", "rm_traceability");

    try {
      const res = await uploadForUrl(data);

      if (res?.status) {
        const fileUrl = res?.data?.data?.uploadedFiles?.[0]?.fileUrl;

        // auto-fill Proof Document URL
        formikForUpdate.setFieldValue("rmImageUrl", fileUrl);

        DataUploadSuccessNotification();
      } else {
        DataUploadFailureNotification(res?.data?.data?.msg);
      }
    } catch (error) {
      DataUploadFailureNotification("Upload failed");
    } finally {
      setIsUploading(false);
    }
  };



  const hideProductImageUrl = true


  const [vendorsListForPlannerSelected, setVendorsListForPlannerSelected] =
    useState("");


  //  useEffect(() => {
  //    getPoNumberByDppId(vendorsListForPlannerSelected?.value,dppIdSelectedForGlobalFilter?.value,jwtToken);
  //  }, [vendorsListForPlannerSelected,dppIdSelectedForGlobalFilter]);
  const [vendorsListForPlannerOptions, setVendorsListForPlannerOptions] =
    useState([]);

  useEffect(() => {
    let tempVendorsListForPlannerOptions = [];
    let data = getPOnumberReducer.PONumber.data
      ? getPOnumberReducer.PONumber.data
      : [];
    data.map((vendorsListForPlanner) => {
      tempVendorsListForPlannerOptions.push({
        label: vendorsListForPlanner.poNumber,
        value: vendorsListForPlanner.poNumber,
      });
    });
    setVendorsListForPlannerOptions(tempVendorsListForPlannerOptions);
  }, [getPOnumberReducer]);

  const handleChangeVendorsListForPlanner = (selectedOption) => {
    setVendorsListForPlannerSelected(selectedOption);

  };
  useEffect(() => {
    getPoNumberByDppId(dppIdSelectedForGlobalFilter?.value, jwtToken);
  }, [dppIdSelectedForGlobalFilter]);


  const DataUploadSuccessNotificationForPonumber = () =>
    toast.success("Po Number Generated Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotificationPonumber = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });



  const [poInsertAttempted, setPoInsertAttempted] = useState(false);

  useEffect(() => {
    if (!poInsertAttempted) return;
    if (getPOnumberInsertReducer.loading) return;

    const { status, error } = getPOnumberInsertReducer;

    if (status === "success") {
      DataUploadSuccessNotificationForPonumber();

      if (dppIdSelectedForGlobalFilter?.value && jwtToken) {
        getRmTraceability(
          dppIdSelectedForGlobalFilter.value,
          jwtToken
        );
      }

      setPoInsertAttempted(false); // 🔥 IMPORTANT
    }

    // if (status === "failure") {
    //   DataUploadFailureNotificationPonumber(
    //     error || "PO Number was not generated"
    //   );
    //   setPoInsertAttempted(false); // 🔥 IMPORTANT
    // }

    if (status === "failure") {
      DataUploadFailureNotificationPonumber("PO Number was not generated");
      setPoInsertAttempted(false);
    }

  }, [
    poInsertAttempted,
    getPOnumberInsertReducer.loading,
    getPOnumberInsertReducer.status,
    getPOnumberInsertReducer.error,
    dppIdSelectedForGlobalFilter?.value,
    jwtToken,
  ]);



  const handleInsertPoNumber = async () => {
    try {
      setPoInsertAttempted(true); // mark that we attempted insert
      await getInsertPoNumber(
        vendorsListForPlannerSelected?.value,
        dppIdSelectedForGlobalFilter?.value,
        jwtToken
      );
    } catch (error) {
      DataUploadFailureNotificationPonumber(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"
      );
    }
  };





  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              alignItems="center"
              px={2}
              ml={-2}
              mb={4}
              gap={1.5}
              mt={-1}
            >
              {allocateAccess && (
                <>
                  {/* ADD BUTTON */}
                  <CreateButton
                    tooltip="Add Rm Items"
                    color="info"
                    variant="contained"
                    type="button"
                    iconOnly
                    onClick={() => {
                      handleAllocateItemModal();
                      getWarehouses(jwtToken);
                      getItemMaster(jwtToken);
                      getAcn(jwtToken);
                      getRelationLocation(jwtToken);
                    }}
                    style={{ borderRadius: "5px" }}
                    size="small"
                  >
                    <Icon>add</Icon>
                  </CreateButton>

                  {/* PO NUMBER DROPDOWN (LEFT OF GENERATE PO) */}
                  <MDBox width="200px">
                    <Select
                      isClearable
                      placeholder="Work Order"
                      className="select-css-for-filter"
                      value={vendorsListForPlannerSelected}
                      options={vendorsListForPlannerOptions}
                      onChange={handleChangeVendorsListForPlanner}
                      autoComplete="off"
                    />
                  </MDBox>

                  {/* GENERATE PO BUTTON */}
                  <Tooltip title="SYNC Data">
                    <IconButton
                      size="small"
                      onClick={handleInsertPoNumber}
                      sx={{
                        border: "1px solid",
                        borderColor: "success.main",
                        color: "success.main",
                        borderRadius: "6px",
                        "&:hover": {
                          backgroundColor: "success.main",
                          color: "#fff",
                        },
                      }}
                    >
                      <Icon>post_add</Icon>
                    </IconButton>
                  </Tooltip>
                </>
              )}

              {/* OTHER BUTTONS */}
              <CSVLink {...csvLink}>
                <DownloadDataButton
                  tooltip="Download Rm Items List"
                  variant="outlined"
                  color="error"
                  iconOnly
                >
                  <Icon>download</Icon>
                </DownloadDataButton>
              </CSVLink>

              <UploadButton
                tooltip="Upload CSV"
                variant="outlined"
                color="info"
                iconOnly
                style={{ marginTop: "2px" }}
                onClick={uploadCsvFilterHandler}
              >
                <Icon>upload</Icon>
              </UploadButton>

              <CSVLink {...csvLink2}>
                <DownloadButton
                  tooltip="Download Template"
                  variant="outlined"
                  color="error"
                  iconOnly
                >
                  <Icon>download</Icon>
                </DownloadButton>
              </CSVLink>
            </MDBox>


            {uploadCsvFilter && (
              <div style={{ margin: "1.5rem 0 1.5rem 1.5rem" }}>

                <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                  <input
                    className="choose_file"
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />

                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>

                <div style={{ marginTop: "8px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload <strong>".csv"</strong> file only
                  </span>
                </div>

              </div>
            )}

            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox mt={-4}>
              {/* {loadingForDynamicColumn && ( */}
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                showTotalEntries={true}
                noEndBorder
                options={{ draggable: false }}
                // serverSidePagination={true}
                // paginationObj={paginationObj}
                pageNoValue={pageNo}
                rowsPerPageValue={rowsPerPage}
                pageNoProp={importPageNo}
                rowsPerPageProp={importRowsPerPage}
                searchProp={importSearch}
                loading={loading}
                hideColumns={hiddenColumsDetails}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
              />
              {/* )} */}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>
                        {/* {singleFgDataForUpdate.industryId === 1 && (
                        <> */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Recycled Material
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="recycledMaterial"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.recycledMaterial}
                            />
                            {formikForUpdate.touched.recycledMaterial &&
                              formikForUpdate.errors.recycledMaterial && (
                                <TextError msg={formikForUpdate.errors.recycledMaterial} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Bio Based Material
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="bioBasedMaterial"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.bioBasedMaterial}
                            />
                            {formikForUpdate.touched.bioBasedMaterial &&
                              formikForUpdate.errors.bioBasedMaterial && (
                                <TextError msg={formikForUpdate.errors.bioBasedMaterial} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Organic Cotton
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="organicCotton"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.organicCotton}
                            />
                            {formikForUpdate.touched.organicCotton &&
                              formikForUpdate.errors.organicCotton && (
                                <TextError msg={formikForUpdate.errors.organicCotton} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Supplier Name{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={200}
                              placeholder="Choose one..."
                              name="supplierId"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "supplierId" },
                                });
                              }}
                              value={supplierIdSelectedForEdit}
                              options={supplierOptions}
                              onChange={(selectedOption) => {
                                handleChangeSupplierForEdit(selectedOption);
                                // getZonesByWarehouse(selectedOption?.value);
                                formikForUpdate.setFieldValue("supplierId", selectedOption);
                              }}
                            />
                            {formikForUpdate.touched.supplierId && formikForUpdate.errors.supplierId && (
                              <TextError msg={formikForUpdate.errors.supplierId} />
                            )}
                          </MDBox>
                        </Grid>
                        {/* </>
                      )} */}
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">
                              Recyclability(%)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="recyclability"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.recyclability}
                              error={
                                formikForUpdate.touched.recyclability &&
                                formikForUpdate.errors.recyclability &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.recyclability &&
                              formikForUpdate.errors.recyclability && (
                                <TextError msg={formikForUpdate.errors.recyclability} />
                              )}
                          </MDBox>
                        </Grid>
                        {/* <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">FG Code</MDTypography>
                            <MDInput
                              type="text"
                              name="FGCode"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.FGCode}
                              error={
                                formikForUpdate.touched.FGCode &&
                                formikForUpdate.errors.FGCode &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.FGCode &&
                              formikForUpdate.errors.FGCode && (
                                <TextError
                                  msg={formikForUpdate.errors.FGCode}
                                />
                              )}
                          </MDBox>
                        </Grid> */}
                        <Grid item xs={12}>
                          <MDBox mb={2} ml={1} >
                            <MDTypography variant="h6" fontWeight={500} mb={1}>
                              Upload Document
                            </MDTypography>

                            <MDBox
                              display="flex"
                              alignItems="center"
                              width="100%"
                              gap={1}
                            >
                              {/* Hidden file input */}
                              <input
                                id="upload-file"
                                type="file"
                                hidden
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];
                                  formikForUpdate.setFieldValue("file", file);
                                }}
                              />

                              {/* Choose File */}
                              <label htmlFor="upload-file">
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                >
                                  Choose File
                                </MDButton>
                              </label>

                              {/* File name – takes remaining width */}
                              <MDBox
                                flex={1}
                                px={2}
                                py={1}
                                sx={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  backgroundColor: "#fafafa",
                                }}
                              >
                                <MDTypography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  title={formikForUpdate.values.file?.name}
                                >
                                  {
                                    formikForUpdate.values.file?.name ??
                                    singleFgDataForUpdate?.name ??
                                    "Not Available"
                                  }

                                </MDTypography>
                              </MDBox>

                              {/* Upload button */}

                            </MDBox>
                          </MDBox>
                        </Grid>



                        {!hideProductImageUrl && (
                          <Grid item xs={12} lg={12}>
                            <MDBox mb={1} ml={1}>
                              <MDTypography variant="h6">RM ImageUrl</MDTypography>
                              <MDInput
                                type="text"
                                name="rmImageUrl"
                                fullWidth
                                autoComplete="off"
                                onBlur={formikForUpdate.handleBlur}
                                onChange={formikForUpdate.handleChange}
                                value={formikForUpdate.values.rmImageUrl}
                                error={
                                  formikForUpdate.touched.rmImageUrl &&
                                  formikForUpdate.errors.rmImageUrl &&
                                  true
                                }
                                inputProps={{
                                  style: {
                                    height: "10px",
                                  },

                                  // maxLength: 45,
                                }}
                              />
                              {formikForUpdate.touched.rmImageUrl &&
                                formikForUpdate.errors.rmImageUrl && (
                                  <TextError msg={formikForUpdate.errors.rmImageUrl} />
                                )}
                            </MDBox>
                          </Grid>)}

                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">
                              Resource Type
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="resourceType"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.resourceType}
                              error={
                                formikForUpdate.touched.resourceType &&
                                formikForUpdate.errors.resourceType &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.resourceType &&
                              formikForUpdate.errors.resourceType && (
                                <TextError msg={formikForUpdate.errors.resourceType} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">
                              Description
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="description"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.description}
                              error={
                                formikForUpdate.touched.description &&
                                formikForUpdate.errors.description &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.description &&
                              formikForUpdate.errors.description && (
                                <TextError msg={formikForUpdate.errors.description} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">
                              Country Origin
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="countryOrigin"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.countryOrigin}
                              error={
                                formikForUpdate.touched.countryOrigin &&
                                formikForUpdate.errors.countryOrigin &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.countryOrigin &&
                              formikForUpdate.errors.countryOrigin && (
                                <TextError msg={formikForUpdate.errors.countryOrigin} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Batch/Serial Number</MDTypography>
                            <MDInput
                              type="text"
                              name="BatchCode"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.BatchCode}
                              error={
                                formikForUpdate.touched.BatchCode &&
                                formikForUpdate.errors.BatchCode &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.BatchCode &&
                              formikForUpdate.errors.BatchCode && (
                                <TextError
                                  msg={formikForUpdate.errors.BatchCode}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Item Code</MDTypography>
                            <MDInput
                              type="text"
                              name="ItemCode"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ItemCode}
                              error={
                                formikForUpdate.touched.ItemCode &&
                                formikForUpdate.errors.ItemCode &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ItemCode &&
                              formikForUpdate.errors.ItemCode && (
                                <TextError
                                  msg={formikForUpdate.errors.ItemCode}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Vendor Name</MDTypography>
                            <MDInput
                              type="text"
                              name="Vendor"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Vendor}
                              error={
                                formikForUpdate.touched.Vendor &&
                                formikForUpdate.errors.Vendor &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Vendor &&
                              formikForUpdate.errors.Vendor && (
                                <TextError
                                  msg={formikForUpdate.errors.Vendor}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">PO Number</MDTypography>
                            <MDInput
                              type="text"
                              name="PONumber"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.PONumber}
                              error={
                                formikForUpdate.touched.PONumber &&
                                formikForUpdate.errors.PONumber &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.PONumber &&
                              formikForUpdate.errors.PONumber && (
                                <TextError
                                  msg={formikForUpdate.errors.PONumber}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">PO Date</MDTypography>
                            <MDInput
                              type="date"
                              name="PODate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.PODate}
                              error={
                                formikForUpdate.touched.PODate &&
                                formikForUpdate.errors.PODate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.PODate &&
                              formikForUpdate.errors.PODate && (
                                <TextError
                                  msg={formikForUpdate.errors.PODate}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">PO Quantity</MDTypography>
                            <MDInput
                              type="number"
                              name="Quantity"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Quantity}
                              error={
                                formikForUpdate.touched.Quantity &&
                                formikForUpdate.errors.Quantity &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Quantity &&
                              formikForUpdate.errors.Quantity && (
                                <TextError
                                  msg={formikForUpdate.errors.Quantity}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">ASN Number</MDTypography>
                            <MDInput
                              type="text"
                              name="ASNNumber"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ASNNumber}
                              error={
                                formikForUpdate.touched.ASNNumber &&
                                formikForUpdate.errors.ASNNumber &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ASNNumber &&
                              formikForUpdate.errors.ASNNumber && (
                                <TextError
                                  msg={formikForUpdate.errors.ASNNumber}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">GRN Number</MDTypography>
                            <MDInput
                              type="text"
                              name="GRNumber"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.GRNumber}
                              error={
                                formikForUpdate.touched.GRNumber &&
                                formikForUpdate.errors.GRNumber &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.GRNumber &&
                              formikForUpdate.errors.GRNumber && (
                                <TextError
                                  msg={formikForUpdate.errors.GRNumber}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">
                              Carbon Foot Print (kg CO₂e)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="carbonFootprint"

                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.carbonFootprint}
                              error={
                                formikForUpdate.touched.carbonFootprint &&
                                formikForUpdate.errors.carbonFootprint &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.carbonFootprint &&
                              formikForUpdate.errors.carbonFootprint && (
                                <TextError
                                  msg={formikForUpdate.errors.carbonFootprint}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography variant="h6">GRN Date</MDTypography>
                            <MDInput
                              type="date"
                              name="GRN Date"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.GRDate}
                              error={
                                formikForUpdate.touched.GRDate &&
                                formikForUpdate.errors.GRDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.GRDate &&
                              formikForUpdate.errors.GRDate && (
                                <TextError
                                  msg={formikForUpdate.errors.GRDate}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">PO Qty UOM</MDTypography>
                            <MDInput
                              type="text"
                              name="poQtyUom"

                              placeholder="Enter UOM"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.poQtyUom}
                              error={
                                formikForUpdate.touched.poQtyUom &&
                                formikForUpdate.errors.poQtyUom &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.poQtyUom &&
                              formikForUpdate.errors.poQtyUom && (
                                <TextError msg={formikForUpdate.errors.poQtyUom} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Supplier Audits{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={80}
                              placeholder="Choose one..."
                              name="SupplierAudits"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "SupplierAudits" },
                                });
                              }}
                              value={warehouseIdSelectedEdit}
                              options={activeDataOptions}
                              onChange={(selectedOption) => {
                                handleChangeWarehouseEdit(selectedOption);
                                getZonesByWarehouse(selectedOption?.value);

                                formikForUpdate.setFieldValue("SupplierAudits", selectedOption);
                                formikForUpdate.setFieldTouched("SupplierAudits", true, true);
                              }}
                            />
                            {formikForUpdate.touched.SupplierAudits && formikForUpdate.errors.SupplierAudits && (
                              <TextError msg={formikForUpdate.errors.SupplierAudits} />
                            )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Source Mapping{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={80}
                              placeholder="Choose one..."
                              name="SourceMapping"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "SourceMapping" },
                                });
                              }}
                              value={warehouseIdSelectedSMEdit}
                              options={activeDataOptions}
                              // onChange={(selectedOption) => {
                              //   handleChangeWarehouseSMEdit(selectedOption);
                              //   getZonesByWarehouse(selectedOption?.value);
                              //   formikForUpdate.setFieldValue("SourceMapping", selectedOption);
                              // }}

                              onChange={(selectedOption) => {
                                handleChangeWarehouseSMEdit(selectedOption);
                                getZonesByWarehouse(selectedOption?.value);

                                formikForUpdate.setFieldValue("SourceMapping", selectedOption);
                                formikForUpdate.setFieldTouched("SourceMapping", true, true);
                              }}
                            />
                            {formikForUpdate.touched.SourceMapping && formikForUpdate.errors.SourceMapping && (
                              <TextError msg={formikForUpdate.errors.SourceMapping} />
                            )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Traceability{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={80}
                              placeholder="Choose one..."
                              name="Traceability"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "Traceability" },
                                });
                              }}
                              value={warehouseIdSelectedTEdit}
                              options={activeDataOptions}
                              // onChange={(selectedOption) => {
                              //   handleChangeWarehouseTEdit(selectedOption);
                              //   getZonesByWarehouse(selectedOption?.value);
                              //   formikForUpdate.setFieldValue("Traceability", selectedOption);
                              // }}
                              onChange={(selectedOption) => {
                                handleChangeWarehouseTEdit(selectedOption);
                                getZonesByWarehouse(selectedOption?.value);

                                formikForUpdate.setFieldValue("Traceability", selectedOption);
                                formikForUpdate.setFieldTouched("Traceability", true, true);
                              }}
                            />
                            {formikForUpdate.touched.Traceability && formikForUpdate.errors.Traceability && (
                              <TextError msg={formikForUpdate.errors.Traceability} />
                            )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Ethical Score (%)</MDTypography>
                            <MDInput
                              type="text"
                              name="ethicalScore"

                              placeholder="percentage"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ethicalScore}
                              error={
                                formikForUpdate.touched.ethicalScore &&
                                formikForUpdate.errors.ethicalScore &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ethicalScore &&
                              formikForUpdate.errors.ethicalScore && (
                                <TextError msg={formikForUpdate.errors.ethicalScore} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Material Purity (%)</MDTypography>
                            <MDInput
                              type="text"
                              name="materialPurity"

                              placeholder="percentage"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.materialPurity}
                              error={
                                formikForUpdate.touched.materialPurity &&
                                formikForUpdate.errors.materialPurity &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.materialPurity &&
                              formikForUpdate.errors.materialPurity && (
                                <TextError msg={formikForUpdate.errors.materialPurity} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6"> Mining Site Name</MDTypography>
                            <MDInput
                              type="text"
                              name="mineName"

                              placeholder=" "
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.mineName}
                              error={
                                formikForUpdate.touched.mineName &&
                                formikForUpdate.errors.mineName &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.mineName &&
                              formikForUpdate.errors.mineName && (
                                <TextError msg={formikForUpdate.errors.mineName} />
                              )}
                          </MDBox>
                        </Grid>


                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Mining Country</MDTypography>
                            <MDInput
                              type="text"
                              name="mineCountry"

                              placeholder=" "
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.mineCountry}
                              error={
                                formikForUpdate.touched.mineCountry &&
                                formikForUpdate.errors.mineCountry &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.mineCountry &&
                              formikForUpdate.errors.mineCountry && (
                                <TextError msg={formikForUpdate.errors.mineCountry} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Refinery Name</MDTypography>
                            <MDInput
                              type="text"
                              name="refineryName"

                              placeholder=" "
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.refineryName}
                              error={
                                formikForUpdate.touched.refineryName &&
                                formikForUpdate.errors.refineryName &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.refineryName &&
                              formikForUpdate.errors.refineryName && (
                                <TextError msg={formikForUpdate.errors.refineryName} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Refinery Country</MDTypography>
                            <MDInput
                              type="text"
                              name="refineryCountry"

                              placeholder=" "
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.refineryCountry}
                              error={
                                formikForUpdate.touched.refineryCountry &&
                                formikForUpdate.errors.refineryCountry &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.refineryCountry &&
                              formikForUpdate.errors.refineryCountry && (
                                <TextError msg={formikForUpdate.errors.refineryCountry} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12}>
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>
                        {/* <MDBox mt={3} ml={10}> */}

                        {/* <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton> */}

                        {/* Submit Button */}
                        <MDButton
                          color="info"

                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create RM Item
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginRight: "10px",
                            marginTop: "4px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12} lg={selectedIndustry === 1 ? 4 : 6}>
                        <MDBox >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            DPP Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DPPID" },
                              });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>
                      {selectedIndustry === 1 && (
                        <>
                          <Grid item xs={12} lg={4}>
                            <MDBox ml={1}>
                              <MDTypography variant="h6">
                                Recycled Material
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="recycledMaterial"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.recycledMaterial}
                              />
                              {formik.touched.recycledMaterial &&
                                formik.errors.recycledMaterial && (
                                  <TextError msg={formik.errors.recycledMaterial} />
                                )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <MDBox ml={1}>
                              <MDTypography variant="h6">
                                Bio Based Material
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="bioBasedMaterial"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.bioBasedMaterial}
                              />
                              {formik.touched.bioBasedMaterial &&
                                formik.errors.bioBasedMaterial && (
                                  <TextError msg={formik.errors.bioBasedMaterial} />
                                )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <MDBox ml={1}>
                              <MDTypography variant="h6">
                                Organic Cotton
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="organicCotton"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.organicCotton}
                              />
                              {formik.touched.organicCotton &&
                                formik.errors.organicCotton && (
                                  <TextError msg={formik.errors.organicCotton} />
                                )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <MDBox mb={1} ml={1}>
                              <MDTypography
                                variant="h6"
                                style={{ fontWeight: "500" }}
                              >
                                {" "}
                                Supplier Name{" "}
                              </MDTypography>

                              <Select
                                // isDisabled={activityIdSelected ? false : true}
                                isClearable
                                className="select-css"
                                maxMenuHeight={200}
                                placeholder="Choose one..."
                                name="supplierId"
                                onBlur={() => {
                                  formik.handleBlur({
                                    target: { name: "supplierId" },
                                  });
                                }}
                                value={supplierIdSelected}
                                options={supplierOptions}
                                onChange={(selectedOption) => {
                                  handleChangeSupplier(selectedOption);
                                  // getZonesByWarehouse(selectedOption?.value);
                                  formik.setFieldValue("supplierId", selectedOption);
                                }}
                              />
                              {formik.touched.supplierId && formik.errors.supplierId && (
                                <TextError msg={formik.errors.supplierId} />
                              )}
                            </MDBox>
                          </Grid>
                        </>
                      )}<Grid item xs={12} lg={selectedIndustry === 1 ? 4 : 6}>

                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Recyclability(%)
                          </MDTypography>
                          <MDInput
                            type="number"
                            name="recyclebility"
                            fullWidth
                            autoComplete="off"

                            // placeholder="Enter number"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.recyclebility}
                            error={
                              formik.touched.recyclebility &&
                              formik.errors.recyclebility &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.recyclebility &&
                            formik.errors.recyclebility && (
                              <TextError msg={formik.errors.recyclebility} />
                            )}
                        </MDBox>
                      </Grid>
                      {/* 
                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">FG Code</MDTypography>
                          <MDInput
                            type="text"
                            name="FGCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.FGCode}
                            error={
                              formik.touched.FGCode &&
                              formik.errors.FGCode &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.FGCode && formik.errors.FGCode && (
                            <TextError msg={formik.errors.FGCode} />
                          )}
                        </MDBox>
                      </Grid> */}

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6" fontWeight={500} mb={0}>
                            Upload RM Image
                          </MDTypography>

                          <MDBox width="100%">
                            <input
                              id="upload-rm-image"
                              type="file"
                              accept=".png,.jpg,.jpeg,.pdf"
                              hidden
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                if (!file) return;

                                formik.setFieldValue("file", file);
                              }}
                            />

                            {!formik.values.file ? (
                              <label htmlFor="upload-rm-image" style={{ display: "block", width: "100%", }}>
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                  fullWidth
                                  sx={{
                                    height: "32.5px",
                                    minHeight: "32.5px",
                                    maxHeight: "32.5px",
                                    padding: "4px 16px",
                                    boxSizing: "border-box",
                                    fontSize: "0.85rem",
                                  }}
                                >
                                  Choose File
                                </MDButton>
                              </label>
                            ) : (
                              <label htmlFor="upload-rm-image" style={{ width: "100%", cursor: "pointer", display: "block", marginTop: "6px" }}>
                                <MDBox
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  px={1.5}
                                  sx={{
                                    height: "32.5px",
                                    border: "1px dashed #1A73E8",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxSizing: "border-box",
                                    transition: "background-color 0.2s",
                                    "&:hover": { backgroundColor: "#f8f9fa" },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    color="text"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      fontSize: "14px",
                                      mr: 1,
                                    }}
                                    title={formik.values.file.name}
                                  >
                                    {formik.values.file.name}
                                  </MDTypography>
                                  <Icon fontSize="small" color="info">edit</Icon>
                                </MDBox>
                              </label>
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6" fontWeight={500} mb={0}>
                            Material Certificate
                          </MDTypography>

                          <MDBox width="100%">
                            <input
                              id="upload-material-certificate"
                              type="file"
                              accept=".png,.jpg,.jpeg,.pdf"
                              hidden
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                if (!file) return;

                                formik.setFieldValue("materialCertificateFile", file);
                              }}
                            />

                            {!formik.values.materialCertificateFile ? (
                              <label htmlFor="upload-material-certificate" style={{ display: "block", width: "100%", }}>
                                <MDButton
                                  variant="outlined"
                                  component="span"
                                  color="info"
                                  fullWidth
                                  sx={{
                                    height: "32.5px",
                                    minHeight: "32.5px",
                                    maxHeight: "32.5px",
                                    padding: "4px 16px",
                                    boxSizing: "border-box",
                                    fontSize: "0.85rem",
                                  }}
                                >
                                  Choose File
                                </MDButton>
                              </label>
                            ) : (
                              <label htmlFor="upload-material-certificate" style={{ width: "100%", cursor: "pointer", display: "block", marginTop: "6px" }}>
                                <MDBox
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  px={1.5}
                                  sx={{
                                    height: "32.5px",
                                    border: "1px dashed #1A73E8",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxSizing: "border-box",
                                    transition: "background-color 0.2s",
                                    "&:hover": { backgroundColor: "#f8f9fa" },
                                  }}
                                >
                                  <MDTypography
                                    variant="body2"
                                    color="text"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      flex: 1,
                                      fontSize: "14px",
                                      mr: 1,
                                    }}
                                    title={formik.values.materialCertificateFile.name}
                                  >
                                    {formik.values.materialCertificateFile.name}
                                  </MDTypography>
                                  <Icon fontSize="small" color="info">edit</Icon>
                                </MDBox>
                              </label>
                            )}

                            {formik.errors.materialCertificateFile && formik.touched.materialCertificateFile && (
                              <MDTypography variant="caption" color="error" mt={0.5} display="block">
                                {formik.errors.materialCertificateFile}
                              </MDTypography>
                            )}
                          </MDBox>
                        </MDBox>
                      </Grid>

                      {!hideProductImageUrl && (
                        <Grid item xs={12} lg={12}>
                          <MDBox mb={2} ml={1}>
                            <MDTypography variant="h6">Rm ImageUrl</MDTypography>
                            <MDInput
                              type="text"
                              name="rmImageUrl"
                              fullWidth
                              autoComplete="off"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.rmImageUrl}
                              error={
                                formik.touched.rmImageUrl &&
                                formik.errors.rmImageUrl &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formik.touched.rmImageUrl &&
                              formik.errors.rmImageUrl && (
                                <TextError msg={formik.errors.rmImageUrl} />
                              )}
                          </MDBox>
                        </Grid>)}

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Resource Type
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="resourceType"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.resourceType}
                            error={
                              formik.touched.resourceType &&
                              formik.errors.resourceType &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.resourceType &&
                            formik.errors.resourceType && (
                              <TextError msg={formik.errors.resourceType} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">
                            Description
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="description"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.description}
                            error={
                              formik.touched.description &&
                              formik.errors.description &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.description &&
                            formik.errors.description && (
                              <TextError msg={formik.errors.description} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Country Origin
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="countryOrigin"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.countryOrigin}
                            error={
                              formik.touched.countryOrigin &&
                              formik.errors.countryOrigin &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.countryOrigin &&
                            formik.errors.countryOrigin && (
                              <TextError msg={formik.errors.countryOrigin} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Batch/Serial Number</MDTypography>
                          <MDInput
                            type="text"
                            name="BatchCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.BatchCode}
                            error={
                              formik.touched.BatchCode &&
                              formik.errors.BatchCode &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.BatchCode &&
                            formik.errors.BatchCode && (
                              <TextError msg={formik.errors.BatchCode} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">Item Code</MDTypography>
                          <MDInput
                            type="text"
                            name="ItemCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ItemCode}
                            error={
                              formik.touched.ItemCode &&
                              formik.errors.ItemCode &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.ItemCode &&
                            formik.errors.ItemCode && (
                              <TextError msg={formik.errors.ItemCode} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Vendor Name</MDTypography>
                          <MDInput
                            type="text"
                            name="Vendor"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Vendor}
                            error={
                              formik.touched.Vendor &&
                              formik.errors.Vendor &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Vendor && formik.errors.Vendor && (
                            <TextError msg={formik.errors.Vendor} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1} >
                          <MDTypography variant="h6">PO Number</MDTypography>
                          <MDInput
                            type="text"
                            name="PONumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.PONumber}
                            error={
                              formik.touched.PONumber &&
                              formik.errors.PONumber &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.PONumber &&
                            formik.errors.PONumber && (
                              <TextError msg={formik.errors.PONumber} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">PO Date</MDTypography>
                          <MDInput
                            type="date"
                            name="PODate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.PODate}
                            error={
                              formik.touched.PODate &&
                              formik.errors.PODate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.PODate && formik.errors.PODate && (
                            <TextError msg={formik.errors.PODate} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">PO Quantity</MDTypography>
                          <MDInput
                            type="number"
                            name="Quantity"

                            // placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Quantity}
                            error={
                              formik.touched.Quantity &&
                              formik.errors.Quantity &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.Quantity &&
                            formik.errors.Quantity && (
                              <TextError msg={formik.errors.Quantity} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">ASN Number</MDTypography>
                          <MDInput
                            type="text"
                            name="ASNNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ASNNumber}
                            error={
                              formik.touched.ASNNumber &&
                              formik.errors.ASNNumber &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.ASNNumber &&
                            formik.errors.ASNNumber && (
                              <TextError msg={formik.errors.ASNNumber} />
                            )}
                        </MDBox>
                      </Grid>



                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">GRN Number</MDTypography>
                          <MDInput
                            type="text"
                            name="GRNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.GRNumber}
                            error={
                              formik.touched.GRNumber &&
                              formik.errors.GRNumber &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.GRNumber &&
                            formik.errors.GRNumber && (
                              <TextError msg={formik.errors.GRNumber} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Carbon Foot Print (kg CO₂e)
                          </MDTypography>

                          <MDInput
                            type="text"
                            name="carbonFootprint"
                            // placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            value={formik.values.carbonFootprint}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.carbonFootprint &&
                              Boolean(formik.errors.carbonFootprint)
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                            }}
                          />

                          {formik.touched.carbonFootprint &&
                            formik.errors.carbonFootprint && (
                              <TextError msg={formik.errors.carbonFootprint} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">GRN Date</MDTypography>
                          <MDInput
                            type="date"
                            name="GRDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.GRDate}
                            error={
                              formik.touched.GRDate &&
                              formik.errors.GRDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.GRDate && formik.errors.GRDate && (
                            <TextError msg={formik.errors.GRDate} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">PO Qty UOM</MDTypography>
                          <MDInput
                            type="text"
                            name="poQtyUom"

                            // placeholder="Enter UOM"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.poQtyUom}
                            error={
                              formik.touched.poQtyUom &&
                              formik.errors.poQtyUom &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.poQtyUom &&
                            formik.errors.poQtyUom && (
                              <TextError msg={formik.errors.poQtyUom} />
                            )}
                        </MDBox>
                      </Grid>


                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            Supplier Audits
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={80}
                            placeholder="Choose one..."
                            name="SupplierAudits"
                            value={warehouseIdSelected}
                            options={activeDataOptions}
                            onBlur={() => {
                              formik.setFieldTouched("SupplierAudits", true);
                            }}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);

                              formik.setFieldValue("SupplierAudits", selectedOption);
                              formik.setFieldTouched("SupplierAudits", true, true);
                            }}
                          />

                          {(formik.touched.SupplierAudits || formik.submitCount > 0) &&
                            formik.errors.SupplierAudits && (
                              <TextError msg={formik.errors.SupplierAudits} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            Source Mapping
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={80}
                            placeholder="Choose one..."
                            name="SourceMapping"
                            value={warehouseIdSelectedSM}
                            options={activeDataOptions}
                            onBlur={() => {
                              formik.setFieldTouched("SourceMapping", true);
                            }}
                            onChange={(selectedOption) => {
                              handleChangeWarehouseSM(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);

                              formik.setFieldValue("SourceMapping", selectedOption);
                              formik.setFieldTouched("SourceMapping", true, true);
                            }}
                          />

                          {(formik.touched.SourceMapping || formik.submitCount > 0) &&
                            formik.errors.SourceMapping && (
                              <TextError msg={formik.errors.SourceMapping} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            Traceability
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={80}
                            placeholder="Choose one..."
                            name="Traceability"
                            value={warehouseIdSelectedT}
                            options={activeDataOptions}
                            onBlur={() => {
                              formik.setFieldTouched("Traceability", true);
                            }}
                            onChange={(selectedOption) => {
                              handleChangeWarehouseT(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);

                              formik.setFieldValue("Traceability", selectedOption);
                              formik.setFieldTouched("Traceability", true, true);
                            }}
                          />

                          {(formik.touched.Traceability || formik.submitCount > 0) &&
                            formik.errors.Traceability && (
                              <TextError msg={formik.errors.Traceability} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Ethical Score (%)</MDTypography>

                          <MDInput
                            type="text"
                            name="ethicalScore"
                            // placeholder="percentage"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ethicalScore}
                            error={
                              (formik.touched.ethicalScore || formik.submitCount > 0) &&
                              !!formik.errors.ethicalScore
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                            }}
                          />

                          {(formik.touched.ethicalScore || formik.submitCount > 0) &&
                            formik.errors.ethicalScore && (
                              <TextError msg={formik.errors.ethicalScore} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Material Purity (%)</MDTypography>
                          <MDInput
                            type="text"
                            name="materialPurity"
                            // placeholder=" "
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.materialPurity}
                            error={
                              (formik.touched.materialPurity || formik.submitCount > 0) &&
                              !!formik.errors.materialPurity
                            }
                            inputProps={{
                              style: { height: "10px" },
                            }}
                          />
                          {(formik.touched.materialPurity || formik.submitCount > 0) &&
                            formik.errors.materialPurity && (
                              <TextError msg={formik.errors.materialPurity} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">
                            Mining Site Name
                            {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="mineName"
                            // placeholder=" "
                            fullWidth
                            autoComplete="off"
                            value={formik.values.mineName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              (formik.touched.mineName || formik.submitCount > 0) &&
                              Boolean(formik.errors.mineName)
                            }
                            inputProps={{
                              style: { height: "10px" },
                            }}
                          />
                          {(formik.touched.mineName || formik.submitCount > 0) &&
                            formik.errors.mineName && (
                              <TextError msg={formik.errors.mineName} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Mining Country
                            {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="mineCountry"
                            // placeholder=" "
                            fullWidth
                            autoComplete="off"
                            value={formik.values.mineCountry}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              (formik.touched.mineCountry || formik.submitCount > 0) &&
                              Boolean(formik.errors.mineCountry)
                            }
                            inputProps={{
                              style: { height: "10px" },
                            }}
                          />
                          {(formik.touched.mineCountry || formik.submitCount > 0) &&
                            formik.errors.mineCountry && (
                              <TextError msg={formik.errors.mineCountry} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1} >
                          <MDTypography variant="h6">
                            Refinery Name
                            {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="refineryName"
                            // placeholder=" "
                            fullWidth
                            autoComplete="off"
                            value={formik.values.refineryName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              (formik.touched.refineryName || formik.submitCount > 0) &&
                              Boolean(formik.errors.refineryName)
                            }
                            inputProps={{
                              style: { height: "10px" },
                            }}
                          />
                          {(formik.touched.refineryName || formik.submitCount > 0) &&
                            formik.errors.refineryName && (
                              <TextError msg={formik.errors.refineryName} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox  >
                          <MDTypography variant="h6">
                            Refinery Country
                            {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="refineryCountry"
                            // placeholder=" "
                            fullWidth
                            autoComplete="off"
                            value={formik.values.refineryCountry}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              (formik.touched.refineryCountry || formik.submitCount > 0) &&
                              Boolean(formik.errors.refineryCountry)
                            }
                            inputProps={{
                              style: { height: "10px" },
                            }}
                          />
                          {(formik.touched.refineryCountry || formik.submitCount > 0) &&
                            formik.errors.refineryCountry && (
                              <TextError msg={formik.errors.refineryCountry} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} mt={2} >
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        fullWidth

                        type="submit"
                        disabled={

                          allocateButtonName === "Please wait..."
                        }
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getRmTraceReducer: state.getRmTraceReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDPPReducer: state.getDPPReducer,
    getDppDocumentsImageReducer: state.getDppDocumentsImageReducer,
    getPOnumberReducer: state.getPOnumberReducer,
    getPOnumberInsertReducer: state.getPOnumberInsertReducer,
    getSupplierTypeReducer: state.getSupplierTypeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getSupplierType: (jwtToken) => dispatch(getSupplierType(jwtToken)),
    getRmTraceability: (dppId, jwtToken) =>
      dispatch(getRmTraceability(dppId, jwtToken)),
    getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createRm: (payload, jwtToken) => dispatch(createRm(payload, jwtToken)),
    deleteRm: (durabilityId, jwtToken) =>
      dispatch(deleteRm(durabilityId, jwtToken)),
    uploadForRmTraceability: (payload, jwtToken) =>
      dispatch(uploadForRmTraceability(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editRM: (payload, jwtToken) => dispatch(editRM(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    uploadForUrl: (payload, jwtToken) =>
      dispatch(uploadForUrl(payload, jwtToken)),
    getPoNumberByDppId: (dppId, jwtToken) =>
      dispatch(getPoNumberByDppId(dppId, jwtToken)),
    getInsertPoNumber: (Ponumber, dppId, jwtToken) =>
      dispatch(getInsertPoNumber(Ponumber, dppId, jwtToken)),

    getDppDocumentsImage: (moduleName, type, name, jwtToken) =>
      dispatch(getDppDocumentsImage(moduleName, type, name, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RMTRACEABILITY);
